export const ThirdPartyDocumentTypes = [
    {
        value: 'internal',
        title: 'Internal',
        creatable: true,
    },
    {
        value: 'external',
        title: 'External',
        creatable: true,
    },
];

export const ThirdPartyDocumentCategories = [
    {
        value: 'Technical Documentation',
        title: 'Technical Documentation',
    },
    {
        value: 'Declaration of Conformity',
        title: 'Declaration of Conformity',
    },
    {
        value: 'Test Reports',
        title: 'Test Reports',
    },
    {
        value: 'Certificates',
        title: 'Certificates',
    },
    {
        value: 'Material Specifications',
        title: 'Material Specifications',
    },
    {
        value: 'Recyclability Assessments',
        title: 'Recyclability Assessments',
    },
    {
        value: 'Audit Reports',
        title: 'Audit Reports',
    },
    {
        value: 'Policies & Procedures',
        title: 'Policies & Procedures',
    },
    {
        value: 'Contracts & Agreements',
        title: 'Contracts & Agreements',
    },
    {
        value: 'Safety Data Sheets (SDS)',
        title: 'Safety Data Sheets (SDS)',
    },
    {
        value: 'Other',
        title: 'Other',
    },
];

export const TECHNICAL_DOCUMENTATION_CATEGORY = 'Technical Documentation';

export const ThirdPartyDocumentConfidentialityLevels = [
    {
        value: 'public',
        title: 'Public',
    },
    {
        value: 'internal',
        title: 'Internal',
    },
    {
        value: 'restricted',
        title: 'Restricted',
    },
    {
        value: 'confidential',
        title: 'Confidential',
    },
];

export const ThirdPartyDocumentUploadedByTypes = [
    {
        value: 'customer',
        title: 'Admin',
        description: 'Uploaded by an admin',
    },
    {
        value: 'third_party',
        title: 'Third Party',
        description: 'Uploaded by the third party',
    },
];

export const DOCUMENT_FILE_MAX_BYTES = 20 * 1024 * 1024;

export const DOCUMENT_FILE_EXTENSIONS = [
    'pdf',
    'txt',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'pptx',
    'jpeg',
    'jpg',
    'png',
];
